import LazyImage from "./lazyimage";
import React, { Suspense } from 'react';
import LoadingSpinner from "./LoadingSpinner";

const Navbar = ({ toggleNavbar, isMobile }) => {
  const ulstyle = "flex-wrap md:flex md:flex-col md:space-y-6  md:space-x-0 items-center w-full"
  const imgstyle = "rounded-2xl max-w-48 shadow-xl shadow-sky-800 mb-4"
  const atagstyle = "block py-0 px-2 md:py-2 md:px-3 text-sm md:text-lg font-medium hover:scale-105 hover:bg-gray-700 rounded-lg transition-all duration-200 text-center min-h-[44px] flex items-center justify-center leading-[44px]";
  const liclass = "mb-0 md:mb-0 text-center"
  return (
    <div className="z-999 navbar courgette-regular bg-gray-800 text-white p-4 md:sticky md:top-0 md:h-screen md:w-64 justify-center items-center flex flex-col">
      <ul className={ulstyle}>
        {!isMobile ? (
          <Suspense fallback={<LoadingSpinner text="Loading image..." />}>
            <LazyImage src={'./images/profile.jpg'} alt="Mirka" className={imgstyle} />
          </Suspense>
          
        ) : null}
        <li className={liclass}>
          <a 
            href="#home" 
            onClick={toggleNavbar}
            className={atagstyle}
          >
            Welcome
          </a>
        </li>
        <li className={liclass}>
          <a 
            onClick={toggleNavbar} 
            href="#about"
            className={atagstyle}
          >
            About me
          </a>
        </li>
        <li className={liclass}>
          <a 
            onClick={toggleNavbar} 
            href="#projects"
            className={atagstyle}
          >
            Programs
          </a>
        </li>
        <li className={liclass}>
          <a 
            onClick={toggleNavbar} 
            href="#contact"
            className={atagstyle}
          >
            Contact me
          </a>
        </li>
        <li className={liclass}>
          <a 
            href="https://www.instagram.com/paradise_energy/" 
            target="_blank" 
            rel="noreferrer"
            className="block p-2 hover:scale-110 transition-all duration-300 rounded-lg hover:bg-gray-700"
            aria-label="Follow on Instagram"
          >
            <img
              src={'./images/insta.png'}
              alt="Instagram"
              className="w-10 h-10 md:w-12 md:h-12 mx-auto"
            />
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Navbar;
